$(document).ready(function() {
	if(!document.querySelector('.compare-wrap')) return false;

	var $compareWrap = $('.compare-wrap'),
		$compareSticky = $compareWrap.find('.compare-sticky'),
		$compareProduct = $compareWrap.find('.compare .compare-product .product-wrap'),
		$compareSpec = $compareWrap.find('.compare .compare-spec .bundle-body .spec-body .spec-wrap'),
		$compareAddProduct = $compareWrap.find('.compare .compare-product .btn-add>a');
		$compareAddFilter  = $('.add-filter');
		$compareCloseFilter =  $compareAddFilter.find('.title-area .close a');

	// back btn
	// 20200406 START 박지영 - back 버튼 동작 오류 수정
	$('.customer-title-wrap .customer-title .previous a, .compare-wrap .visible-sticky .previous a').on('click', function(e) {
		e.preventDefault();
		history.back();
	});
	// 20200406 END

	// email 
	$('.customer-title .print a.page-email, .compare-product .btn-add .print a.page-email').off('click').on('click', function(e) {
		e.preventDefault();
		adobeTrackEvent('compare-email', {page_event : {send_compare_result_to_email : true}});
		// change <br> to %0D%0A to show on the new line in email
		var title = encodeURIComponent($(this).data('title')) + ' ';
		var body = $(this).data('body').replace(/\<br\>/gi, '\n'); // jshint ignore:line
		//console.log(body);
		var url = encodeURIComponent(body+$(this).attr('href'));
		var mailto = 'mailto:?subject='+ title +'&body='+url;
		location.href = mailto;
	});
	// print
	$('.customer-title .print a.page-print, .compare-product .btn-add .print a.page-print').off('click').on('click', function(e) {
		e.preventDefault();
		adobeTrackEvent('compare-print', {page_event : {print_compare_result : true}});
		var _this = $(this),
			url = _this.attr('href'),
			left = Math.round(screen.width/2 - 600),
			top = 0;

		window.open(url,'_blank','left=' + left + ',top=' + top + ',width=1000,height=' + Math.round(screen.height - 100) + ',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
		return false;

	});

	if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS') || COUNTRY_CODE.toLowerCase()=='de') { //LGEDE-926

		// show/hide product (+filter) list
		var productList = {
			init: function() {
				// bind event
				$compareAddProduct.on('click', function(e) {
					// show
					e.preventDefault();
					$compareAddProduct.hide();
					$(plp.el.form).submit();
					$compareAddFilter.slideDown(300).attr('tabindex', -1).focus();
					setTimeout(function() {
						$('html, body').stop().animate({scrollTop:0}, 500);
					}, 300);
				});
				$compareCloseFilter.on('click', function(e) {
					// hide
					e.preventDefault();
					$compareAddProduct.show();
					$compareAddFilter.slideUp(300);
					$compareAddProduct.focus();
					// 20200309 START 박지영 - Compare 페이지에서 Save 하지 않고 필터 영역 닫을때, Save 하지 않은 제품을 버튼 초기화.
					var allObjList = $('#resultAppendTarget').find('.products-info .button');
					// 20200429 START 박지영 - 콘솔 로그 삭제
					//console.log('!allObjList');
					// 20200429 END
					allObjList.each(function() {
						$(this).find('a').eq(0).removeClass('active');
						$(this).find('a').eq(1).addClass('active');
					});
					tempCookie = getCookie(compareCookie.name);
					$('#categoryFilterForm').trigger('appended');
					// 20200309 END 
					setTimeout(function() {
						$('html, body').stop().animate({scrollTop:0}, 100);
					}, 300);
				});
				this.addAriaDescribedby();
			},
			addAriaDescribedby: function(){
				var waNumber = 0;
				$compareWrap.find('.product-list .item').each(function() {
					var $target;
					if($(this).find('.model-name a') && !$(this).find('.model-name a').is(':empty')) {
						$target = $(this).find('.model-name a');
					}
					if($target) {
						$target.attr('id', 'waCompare_'+waNumber);
						//LGEIN-125, LGEVN-80
						var obsBuynowFlag = $('#obsBuynowFlag').val();
						if(obsBuynowFlag == 'Y'){
							$(this).find('a.btn').attr('aria-describedby', 'waCompare_'+waNumber);
						}else {
							$(this).find('a.btn').attr('aria-describedby', 'waCompare_'+waNumber).attr('role', 'button');
						}
						$(this).find('a.js-compare').attr('aria-describedby', 'waCompare_'+waNumber).attr('role', 'button');
						// $(this).find('.controls a').attr('aria-describedby', 'waCompare_'+waNumber).attr('role', 'button');
						waNumber++;
					}
				});
			}
		};
		productList.init();

		var itemWidth = $compareProduct.find('.item').eq(0).outerWidth(),
			itemLength = $compareProduct.find('.item').length,
			maxLength = 3,
			currentSwipe = 0;
			if($(window).width()>991) {
				maxLength=3;
			} else {
				maxLength=2;
			}

			if(maxLength<itemLength) {
				$compareWrap.find('.compare .compare-product .controls-products a.next').addClass('active');
			}

		var maxProducts = ($compareWrap.data('type-plp')==true) ? 6:3;
		$('#compare_alert .modal-body .maximum .number').html(maxProducts);

		// add/remove product 
		var tempCookie = getCookie(compareCookie.name);
		// scripts to run after product list changes
		$('#categoryFilterForm').on('appended', function() {
			var isCookie = false;
			if(!tempCookie) {
				isCookie = false;
			} else {
				if(tempCookie.split('|').length>0) {
					isCookie = true;
				}
			}
			// 20200326 START 박지영 : compare 처리
			// reset
			$('#resultAppendTarget').find('.products-info .button a.btn-outline-secondary').removeClass('active');
			$('#resultAppendTarget').find('.products-info .button a.btn-primary').addClass('active');
			// 20200326 END
			
			if(isCookie) {
				var tc = tempCookie.split('|');
				//console.log(tc);
				for(var i=0;i<tc.length;i++) {
					if(tc[i]!="") {
						var myobj = $('#resultAppendTarget').find('.products-info .button[data-model-id='+tc[i]+'] a');
						myobj.eq(0).addClass('active');
						myobj.eq(1).removeClass('active');
					}
				}
			}
		});
		var controlProduct = {
			$remove : $compareProduct.find('.product-list .item .controls a.remove'),
			init : function() {
				this.$remove.on('click', function(e) {
					e.preventDefault();
					var pid = $(this).closest('.item').data('model');
					var categoryId = $('#categoryFilterForm input[name=categoryId]').val();
					var bizType = $('#categoryFilterForm input[name=bizType]').val();
					if(pid) {
						compareCookie.remove(pid);
						if($compareProduct.find('.item').length <= 1) {
							var html = '<form method="post" action="'+window.location.href+'" id="tempCompareRemoveForm"><input type="hidden" name="categoryId" value="'+categoryId+'" /><input type="hidden" name="bizType" value="'+bizType+'" /></form>';
							$('body').append(html);
							$('#tempCompareRemoveForm').submit();
						} else {
							//location.reload();
							if(bizType=="B2B") window.location.href = '//' + location.host + location.pathname + '?bizType=' + bizType;
							else window.location.href = '//' + location.host + location.pathname + '?bizType=' + bizType;
						}
					}
				});
				$compareAddFilter.on('click', '.result-box .list-box .button a, .result-other-box .list-box .button a', function(e) {
					e.preventDefault();
					//if(!tempCookie) return false;
					// toggle button (remove, add to compare)
					// 20200326 START 박지영 : compare 처리
					var pid = $(this).parent().attr('data-model-id');
					// 20200326 END
					if($(this).index()==0) {
						// button name = remove : delete from tempCookie
						controlProduct.removeTemp(pid);
					} else {
						// button name = add to compare : add from tempCookie
						controlProduct.addTemp(pid);
						adobeTrackEvent('add-to-compare', {
							products : [{
								sales_model_code : findSalesModel($(this)), /* LGEGMC-455 20200722 modify */
								model_name : findModelName($(this))
							}],
							page_event : {add_to_compare : true}
						});
					}
					if(tempCookie.split('|').length>maxProducts) {
						$('#compare_alert').modal();
						controlProduct.removeTemp(pid);
					} else {
						// change button
						$(this).removeClass('active').siblings().addClass('active');
					}
				});
				$compareAddFilter.on('click', '.result-box .btn-area button, .result-other-box .btn-area button', function(e) {
					e.preventDefault();
					var idx = $(this).index();
					if($(this).hasClass('disabled')) return false;
					var $page = $('#categoryFilterForm').find('input[type=hidden][name=page]');
					page = $page.val();
					if(!page || page<=0) {
						page=1;
					}
					if(idx==0) {
						// prev
						page--;
						if(page<=0) page=1;
						$page.val(page);
						setTimeout(function() {
							// ajax call (load products list)
							$(plp.el.form).submit();
						}, 100);
					} else if(idx==1) {
						// next
						page++;
						$page.val(page);
						setTimeout(function() {
							// ajax call (load products list)
							$(plp.el.form).submit();
						}, 100);
					} else {
						// submit
						var obj = $compareAddFilter.find('.result-box .list-box li, .result-other-box .list-box li');
						if(tempCookie) {
							if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
								setCookie(compareCookie.name, tempCookie, true);
							}
						} else {
							removeCookie(compareCookie.name, true);
						}
						var bizType = $('#categoryFilterForm input[name=bizType]').val();
						setTimeout(function() {
							//$('html, body').scrollTop(0);
							// location.reload();
							var categoryId = $('#categoryFilterForm input[name=categoryId]').val();
							var bizType = $('#categoryFilterForm input[name=bizType]').val();
							if(tempCookie) {
								if(bizType=="B2B") window.location.href = '//' + location.host + location.pathname + '?bizType=' + bizType;
								else window.location.href = '//' + location.host + location.pathname + '?bizType=' + bizType;
							} else {
								var html = '<form method="post" action="'+window.location.href+'" id="tempCompareRemoveForm"><input type="hidden" name="categoryId" value="'+categoryId+'" /><input type="hidden" name="bizType" value="'+bizType+'" /></form>';
								$('body').append(html);
								$('#tempCompareRemoveForm').submit();
							}
						}, 300);
					}
				});
			},
			addTemp: function(productId){
				var cookie = tempCookie;
				if(cookie) {
					cookie = cookie.indexOf('|') >= 0 ? cookie.split('|') : [cookie];

					if(cookie.indexOf(productId) < 0) {
						cookie.unshift(productId);
					}
					cookie = cookie.join('|');
				}else {
					cookie = productId;
				}
				tempCookie = cookie;
			},
			removeTemp: function(productId){
				var cookie = tempCookie;
				if(cookie) {
					var idx;
					cookie = cookie.indexOf('|') >= 0 ? cookie.split('|') : [cookie];
					idx = cookie.indexOf(productId);
					if(idx >= 0) {
						cookie.splice(idx, 1);
					}
					cookie = cookie.join('|');
				}
				if(cookie == '' || !cookie) {
					tempCookie = '';
				}else {
					tempCookie = cookie;
				}
			}
		};
		controlProduct.init();

		// lock/unlock
		var compareLock = {
			$el : $compareProduct.find('.product-list .item .controls a.lock'),
			$container1 : $compareProduct.find('.product-crop'),
			$container2 : $compareSpec.find('.tds-crop'),
			init: function() {
				if($compareProduct.find('.item').length <= 2) {
					$compareProduct.find('.item').find('.controls a.lock').hide();
				}
				// bind event
				this.$el.on('click', function(e) {
					e.preventDefault();
					var lockText = xssfilter($(this).data('lock'));
					var unlockText = xssfilter($(this).data('unlock'));
					var modelId = $(this).closest('.item').data('model');
					if($(this).closest('.item').hasClass('locked')) {
						removeCookie('LG5_CompareLock');
						$compareWrap.find('.locked').removeClass('locked');
						$(this).html(lockText);
					} else {
						if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS') || COUNTRY_CODE.toLowerCase()=='de' || COUNTRY_CODE.toLowerCase()=='it') { //LGEDE-926,LGEIS-1124
							setCookie('LG5_CompareLock', modelId);
						}
						// init
						$compareWrap.find('.locked').removeClass('locked');
						compareLock.$el.not($(this)).html(lockText);
						$(this).html(unlockText);
						// apply lock
						var idx = $(this).closest('.item').index();
						compareLock.$container1.addClass('locked').find('.item').eq(idx).addClass('locked');
						compareLock.$container2.addClass('locked').each(function() {
							$(this).find('.item').eq(idx).addClass('locked');
						});
					}
				});
				// check the cookie
				var currCookie = getCookie('LG5_CompareLock');
				if(currCookie && $compareProduct.find('.item').length > 2) {
					$compareProduct.find('.item[data-model='+currCookie+']').find('.controls a.lock').trigger('click');
				}
			}
		};
		compareLock.init();

		// product list Slide (left/right slide)
		var compareSlide = {
			$el : $compareWrap.find('.compare .compare-product .controls-products a'),
			$prev : $compareWrap.find('.compare .compare-product .controls-products a.prev'),
			$next : $compareWrap.find('.compare .compare-product .controls-products a.next'),
			/* LGEUS-11787 : 20190808 add*/
			$swipelist : $compareWrap.find('.compare-inner .compare-product .product-list, .compare-spec .spec-body .spec-wrap .tds-wrap'),
			/* //LGEUS-11787 : 20190808 add*/
			init: function() {
				var _this = this;
				this.$el.on('click', function(e) {
					e.preventDefault();
					if($(this).hasClass('prev')) {
						// prev
						currentSwipe++;
					} else {
						// next
						currentSwipe--;
					}
					compareSlide.runSlide(currentSwipe);
				});
				/* LGEUS-11787 : 20190808 add*/ 
				if($('header').attr('class').match('mobile-device')){
					this.$swipelist.on('touchstart', function(e){
						var startEvent=0,endEvent=0,changEvent=0;
						startEvent = e.originalEvent.touches[0].screenX;
						$(this).on('touchend', function(y) {
							if(endEvent ==0){
								endEvent = y.changedTouches[0].screenX;
								changeEvnet = startEvent - endEvent;
								if(changeEvnet > 50&& _this.$next.attr('class').match('active')){
									_this.$next.click();
								}else if(changeEvnet < -50&& _this.$prev.attr('class').match('active')){
									_this.$prev.click();
								}
							}
						});
					});
				}
				/* //LGEUS-11787 : 20190808 add*/
			},
			runSlide : function(val) {
				// check currentSwipe;
				// 20200609 START 박지영 - 넓이 재계산
				itemWidth = $compareProduct.find('.item').eq(0).outerWidth();
				// 20200609 END
				if(currentSwipe>0) currentSwipe=0;
				if(currentSwipe<((itemLength-maxLength)*-1)) currentSwipe=(itemLength-maxLength)*-1;

				// show/hide buttons
				if(currentSwipe<0) {
					compareSlide.$prev.addClass('active');
				} else {
					compareSlide.$prev.removeClass('active');
				}
				if(currentSwipe<=(itemLength-maxLength)*-1) {
					compareSlide.$next.removeClass('active');
				} else {
					compareSlide.$next.addClass('active');
				}
				// run slide
				var $obj1 = $compareProduct.find('.product-list');
				var $obj2 = $compareSpec.find('.tds');
				var left = val*itemWidth;
				var dm = -1; // default margin for css
				var ml = dm+left,
					mr = (dm+left)*-1;
				mr=mr-1.2; // for ipad pro
				// 20200408 START 이상현 - compare 아이템 슬라이드 : rtl 케이스 추가 
				if( $('html').attr('dir') === 'ltr' ){
					//if(mr==1) mr=0;
					$obj1.stop().animate({'margin-left':ml, 'margin-right':mr}, 300);
					$obj2.stop().animate({'margin-left':ml, 'margin-right':mr}, 300);
				}else if( $('html').attr('dir') === 'rtl' ){
					$obj1.stop().animate({'margin-right':ml, 'margin-left':mr}, 300);
					$obj2.stop().animate({'margin-right':ml, 'margin-left':mr}, 300);
				}
				// 20200408 END
				//console.log(left);
			}
		};
		compareSlide.init();

		// show all/diff/selection area
		var compareTechSpec = {
			$elDesktop :$compareWrap.find('.compare-control .controls.desktop div a'),
			$elMobile :$compareWrap.find('.compare-control .controls.mobile select'),
			$elTh : $compareSpec.find('.th input[type=checkbox]'),
			init : function(e) {
				// script to run when you click the text button for desktop
				this.$elDesktop.on('click', function(e) {
					e.preventDefault();
					var val = $(this).data('value');
					if(!$(this).hasClass('disabled')) {
						compareTechSpec.checkValue(val);
						$(this).closest('.controls').find('div a').not($(this)).removeClass('active');
						$(this).addClass('active');
					}
				});
				// script to run when changing the selection box for mobile
				this.$elMobile.on('change', function(e) {
					e.preventDefault();
					var val = $(this).val();
					compareTechSpec.checkValue(val);
				});
				// if you click a checkbox and even one item is checked, the selection button is available.
				this.$elTh.on('change', function(e) {
					e.preventDefault();
					//$(this).prop('checked');
					var len = compareTechSpec.$elTh.length;
					var all = 0;
					for(var i=0;i<len;i++) {
						var checked = compareTechSpec.$elTh.eq(i).prop('checked');
						if(checked) all++;
					}
					if(all>0) {
						// change the selection button to available
						compareTechSpec.$elDesktop.eq(0).parent().parent().find('.select a').removeClass('disabled').removeClass('aria-disabled');
						compareTechSpec.$elMobile.find('option:last-child').removeAttr('disabled');
					} else {
						// disable the selection button
						compareTechSpec.$elDesktop.eq(0).parent().parent().find('.select a').addClass('disabled').attr('aria-disabled', true);
						compareTechSpec.$elMobile.find('option:last-child').attr('disabled', 'disabled');
					}
				});
				// init
				// LGEAT-54 Start
				var countryCode = $('html').data('countrycode').toUpperCase();
				if(countryCode == 'AT') this.runAll();
				else this.runDiff();
				// LGEAT-54 End
				if($(window).width()<768) {
					setTimeout(function() {
						compareCollapse.$btnAll.parent().find('a.collapse').trigger('click');
					}, 300);
				}
			},
			checkValue : function (val) {
				compareCollapse.$btnAll.parent().find('a.expand').trigger('click');
				if(val=='all') {
					this.runAll();
				} else if(val=='differences') {
					this.runDiff();
				} else if(val=='selection') {
					this.runSelect();
				}
			},
			runAll : function() {
				$compareSpec.find('.diff').removeClass('diff');
				$compareSpec.show();
			},
			runDiff : function() {
				$compareSpec.show();
				var len = $compareSpec.length;
				for(var i=0;i<len;i++) {
					var len2 = $compareSpec.eq(i).find('.item').length;
					var defaultHtml = $compareSpec.eq(i).find('.item').eq(0).html();
					var isDifference = 0;
					for(var j=1;j<len2;j++) {
						var currHtml = $compareSpec.eq(i).find('.item').eq(j).html();
						if(defaultHtml!=currHtml) isDifference=1;
					}
					if(isDifference==1) {
						$compareSpec.eq(i).find('.tds-crop').addClass('diff');
					} else {
						$compareSpec.eq(i).find('.tds-crop').removeClass('diff');
					}
				}
			},
			runSelect : function() {
				var len = compareTechSpec.$elTh.length;
				for(var i=0;i<len;i++) {
					var checked = compareTechSpec.$elTh.eq(i).prop('checked');
					if(checked) {
						$compareSpec.eq(i).show();
					} else {
						$compareSpec.eq(i).hide();
					}
				}
			}
		};
		compareTechSpec.init();

		// collapse/expand
		var compareCollapse = {
			$el1:$compareWrap.find('.compare-spec .spec-box .bundle-header'),
			$el2:$compareWrap.find('.compare-spec .bundle-body .spec-header'),
			$btnAll:$compareWrap.find('.compare-control .right-area a'),
			init: function(e) {
				this.eventBinding();
			},
			eventBinding: function(e) {
				this.$btnAll.on('click', function(e) {
					e.preventDefault();
					if($(this).hasClass('collapse')) {
						// collapse
						compareCollapse.$el2.removeClass('active');
						$(this).parent().addClass('expand');
					} else {
						// expand
						compareCollapse.$el1.addClass('active');
						compareCollapse.$el2.addClass('active');
						$(this).parent().removeClass('expand');
					}
					var h = parseInt($(window).height());
					var hf = 0;
					if(h>480) {
						hf = 336;
					} else {
						hf = 240;
					}
					var ht = parseInt($compareWrap.find('.compare-spec').offset().top) - hf;
					$('html, body').stop().animate({scrollTop:ht}, 100);
				});
				this.$el1.find('a').on('click', function(e) {
					e.preventDefault();
					$(this).parent().toggleClass('active');
				});
				this.$el2.find('a').on('click', function(e) {
					e.preventDefault();
					if(!$(this).parent().hasClass('active')) compareCollapse.$btnAll.parent().removeClass('expand');
					$(this).parent().toggleClass('active');
				});
			}
		};
		compareCollapse.init();

		// fix size on resize
		var fixSize = {
			/*
			$el:$compareSpec.find('.tds'),
			init: function(e) {
				this.$el.find('.item').removeAttr('style');
				this.runFixSize();
			},
			runFixSize : function(e) {
				var max = 0;
				this.$el.each(function() {
					$(this).find('.item').each(function() {
						var h = $(this).outerHeight();
						if(h>max) max=h;
					});
					$(this).find('.item').css('height', max);
				});
			}
			*/
			init: function(e) {
				$compareSpec.each(function() {
					var max = 0;
					var h1 = $(this).find('.th').outerHeight();
					if($(window).width()>=768) {
						if(h1>max) max=h1;
					}
					$(this).find('.tds .item').each(function() {
						var h2 = $(this).outerHeight();
						if(h2>max) max=h2;
					});
					$(this).find('.tds .item').css('height', max);
				});
				// 20200429 START 박지영 - 제품 리스트 Height 계산하여 max로 반영
				fixSize.height();
				// 20200429 END
			},
			// 20200429 START 박지영 - 제품 리스트 Height 계산하여 max로 반영
			height: function(e) {
				var max = 0;
				$compareProduct.find('.product-list .item').css('height', 'auto');
				$compareProduct.find('.product-list .item').each(function() {
					if($(this).outerHeight() > max) max= $(this).outerHeight();
				});
				$compareProduct.find('.product-list .item').css('height', max);
			}
			// 20200429 END
		};
		fixSize.init();

		$(window).resize(function() {
			fixSize.init();
			itemWidth = $compareProduct.find('.item').eq(0).outerWidth();
			var ww = $(window).width();
			if(ww>991) {
				maxLength=3;
			} else {
				maxLength=2;
			}
			if(maxLength<itemLength) {
				$compareWrap.find('.compare .compare-product .controls-products a.next').addClass('active');
			}
			if(currentSwipe!=0) compareSlide.runSlide(currentSwipe);
		});

		// sticky bar
		var compareTop=$compareWrap.offset().top;
		// 20200429 START 박지영 - 제품 리스트 Height 계산하여 max로 반영
		var fixCompareSticky = function() {
			compareTop=$compareWrap.offset().top;
			var st = parseInt($(window).scrollTop());
			if(compareTop < st) {
				if(!$compareSticky.hasClass('floating')) {
					$compareSticky.addClass('floating');
					fixSize.height();
				}
			} else {
				if($compareSticky.hasClass('floating')) {
					$compareSticky.removeClass('floating');
					fixSize.height();
				}
			}
		};
		// 20200429 END
		$(window).scroll(function() {
			fixCompareSticky();
		});
		fixCompareSticky();

	} else {
		ePrivacyCookies.view('load', '', $('.compare-wrap .compare .compare-product .product-wrap .product-list'));
		$('.compare-control').remove();
		$('.compare-spec').remove();
		$('.add-filter').remove();
	}

	
	runBVStaticPLP($('.compare .product-list'));

});